import Sites from "../../../components/Sites";

export default function AdminSite() {
    return (<>
        <Sites title={'admin'} />
    </>)
}